import { InputTextarea } from "primereact/inputtextarea";
import { FormField } from "@/ds";
import { EquipeDialog } from "../equipe-dialog";
import {
  CONFIRMAR_LABEL,
  JUSTIFICATIVA_LABEL,
  JUSTIFICATIVA_REQUIRED_HINT,
  VOLTAR_LABEL,
} from "../equipe-obra.constants";
import styles from "./verificacao-dialog.module.scss";
import type {
  VerificacaoDialogProps,
  VerificacaoDialogViewModel,
} from "./types-verificacao-dialog";

/**
 * Diálogo de verificação da equipe (HU 2059/2530): o "Warning Modal" do Figma com justificativa
 * obrigatória, validada em tela antes de confirmar.
 */
export function VerificacaoDialogView(props: VerificacaoDialogProps & VerificacaoDialogViewModel) {
  const {
    justificativa,
    alterarJustificativa,
    erro,
    confirmar,
    testId,
    testIds,
    compacto,
    title,
    subtitle,
    children,
    justificativaPlaceholder,
    linhas,
    maxLength,
    rodapeLargo,
    onVoltar,
  } = props;

  return (
    <EquipeDialog
      dialogTestId={testIds.dialog}
      testId={testId}
      title={title}
      subtitle={subtitle}
      voltarLabel={VOLTAR_LABEL}
      confirmarLabel={CONFIRMAR_LABEL}
      rodapeLargo={rodapeLargo}
      onVoltar={onVoltar}
      onConfirmar={confirmar}
    >
      {children}
      <FormField.Root
        id={testIds.justificativa}
        className={`${styles.campo} ${compacto ? styles.campoCompacto : ""}`}
        error={erro}
      >
        <div className={styles.rotulo}>
          <FormField.Label className={compacto ? styles.rotuloCompacto : undefined}>
            {JUSTIFICATIVA_LABEL}
          </FormField.Label>
          <span className={styles.dica}>{JUSTIFICATIVA_REQUIRED_HINT}</span>
        </div>
        <FormField.Control>
          <InputTextarea
            value={justificativa}
            placeholder={justificativaPlaceholder}
            rows={linhas}
            autoResize={false}
            maxLength={maxLength}
            required
            aria-required
            className={compacto ? styles.umaLinha : styles.textarea}
            onChange={(event) => alterarJustificativa(event.currentTarget.value)}
            data-testid={testIds.justificativa}
          />
        </FormField.Control>
        <FormField.Error data-testid={testIds.justificativaErro} />
      </FormField.Root>
    </EquipeDialog>
  );
}
